import React, { useEffect, useState } from "react";
import { Tab } from 'react-bootstrap';
import RoleHistoryReportTopFilter from "./RoleHistoryReportTopFilter";
import { MasterService } from "../../services";
import Loader from "../common/loader";
import RoleHistoryListingTable from './RoleHistoryListingTable';
import { getFirstDate } from '../../config/helper';
const RoleHistoryReport = () => {
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0)
    const [isPageReset, setPageReset] = useState(0);
    const [isReset] = useState(0);
    const [rolehistory_search_params, setRolehistorySearchParams] = useState({})
    const [role_history_data, setRoleHistoryData] = useState([]);

    useEffect(() => {
        let params = {
            start_date: getFirstDate(new Date()),
            end_date: new Date(),
            page: 1,
        }
        getRoleHistoryData(1, params, true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getRoleHistoryData = async (page_no, params, page_reset) => {
        let result = []
        if(page_reset){
            setPageReset(isPageReset+1)
        }
        let temp_search_params = { ...rolehistory_search_params }
        if (Object.keys(params).length) {
            setRolehistorySearchParams(params)
            temp_search_params = params
        } else {
            temp_search_params.page = page_no
        }

        setLoading(true)
        await MasterService.post('/sfa/user/user_role_history_list', temp_search_params).then(function (response) {
            if (response && response.data && response.data.status === 200 &&  response.data.data && response.data.data.role_history) {
                let tempPageCount = Math.ceil(response.data.data.allPackageListcount / response.data.data.per_page);
                setRoleHistoryData(response.data.data.role_history)
                setPageCount(tempPageCount);
            }else{
                setRoleHistoryData([])
                setPageCount(0);
                // setRoleHistoryCount(0)
                setLoading(false)
            }
            setLoading(false);
        }).catch(function (response) {
            setLoading(false)
        });
        return result;
    }

    const getExportData = async (params) => {
        let postData = rolehistory_search_params;
        let result = []
        setLoading(true)
        await MasterService.post('/sfa/user/user_role_history_report', postData)
            .then(function (response) {
                if (response && response.data && response.data.status === 200 &&  response.data.data) {
                    result = response.data.data;
                }
            })
            .catch(function (response) {
            });
            setLoading(false)
        return result
    }

    return (
        <React.Fragment>
            {loading ? <Loader /> : null}
            <div className="container-fluid">
                <div className="dealer-user-mapping-user">
                    <div className="top-heading d-flex">
                        <h1>Role History Report</h1>
                    </div>
                    <div className='visit-filter-outer'>
                        <RoleHistoryReportTopFilter isReset={isReset} getRoleHistoryData={getRoleHistoryData} />
                    </div>
                    <div className="dealer-user-mapping-tab-outer no-visit-report-outer">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <RoleHistoryListingTable
                                        getRoleHistoryData={getRoleHistoryData}
                                        pageCount={pageCount}
                                        isPageReset={isPageReset}
                                        roleHistoryData={role_history_data}
                                        loading={loading}
                                        getExportData={getExportData}
                                    />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default RoleHistoryReport;